// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"36423bff","355":"997a7ffb","413":"9d576a3a","453":"588ecfcc","509":"23aeac14","796":"fabcb31a","952":"50b7a4bf"}[chunkId] + ".chunk.js";
};